import React, { useState, useEffect } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import ContractContainer from 'app/containers/ContractContainer';
import WorkContainer from 'app/containers/WorkContainer';
import CourseAvailableContainer from 'app/containers/CourseAvailableContainer';
import TextInput from 'app/components/TextInput';
import TextEvents from 'app/components/TextEvents';
import { styles, useStyles } from './CreateCommunicationProgramStyles';
import { useDispatch, useSelector } from 'react-redux';
import Highlighter from 'react-highlight-words';

import { Modal, Select, Input, Icon, DatePicker, Transfer, Button, Tooltip, Spin, Table, Badge, Row, Col, Tabs, Checkbox, message } from 'antd';
import ApiService from 'app/services/ApiService'
import searchMultiple from 'app/utils/SearchMultiple';
import moment from 'moment';
import {
    fetchCommunicationProgram,
    clearCommunicationProgram,
    fetchCommunicationProgramFilter,
    clearcommunicationProgramFilter,
    getEmployeesBycategory,
    getEmployeesByIdEmployee,
    getEmployeeLayout,
    getExternalEmployees
} from 'app/actions/CommunicationProgramActions';

import { courseAvailableClear } from 'app/actions/CourseAvailableActions'
import { employeeById } from 'app/reducers';
import * as TrainingActions from '../../actions/TrainingActions';
import ModalProcedureAssignation from 'app/components/CreateCommunicationProgram/ModalProcedureAssignation/ModalProcedureAssignation';
import { removeCourseUsed } from '../../actions/CourseAvailableActions';
import { Paper } from '@material-ui/core';

import AttachFileXLSX from 'app/containers/AttachFileXLSX/AttachFileXLSX';

const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;
const { RangePicker } = DatePicker

export default function CreateCommunicationProgram(props) {
    const { TabPane } = Tabs;
    const classes = useStyles();
    const dispatch = useDispatch();
    const [id, setId] = useState(0);
    const [idProgram, setIdProgram] = useState();
    const [activeKey, setTabBar] = useState('1');
    const [name, setName] = useState('');
    const [description, setDesc] = useState('');
    const [subdir, setSubdir] = useState([]);
    const [contract, setContract] = useState(undefined);
    const [work, setWork] = useState(undefined);
    const [open, setOpen] = useState(false);
    const [isCommunicationProgram, setCommunicationProgramStatus] = useState(false);
    const [oilService, setOilService] = useState(false);
    const [idTraining, setIdTraining] = useState(undefined);
    const [isSaved, setIsSaved] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState();
    const [questions, setQuestions] = useState([]);
    const employeeData = useSelector(employeeById);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [visibleModalProcedureAssign, setVisibleModalProcedureAssign] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [visibleModalEditAssignment, setVisibleModalEditAssignment] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [notApply, setNotApply] = useState(false);

    const [selectedRowsFile, setSelectedRowsFile] = useState([]);
    const [selectedRowKeysFile, setSelectedRowKeysFile] = useState([]);

    const [selectedRowKeysAvailableFile, setSelectedRowKeysAvailableFile] = useState([]);
    const [selectedRowsAvailableFile, setSelectedRowsAvailableFile] = useState([]);

    const [selectedRowsExternal, setSelectedRowsExternal] = useState([]);
    const [selectedRowKeysExternal, setSelectedRowKeysExternal] = useState([]);

    const [selectedRowKeysAvailableExternal, setSelectedRowKeysAvailableExternal] = useState([]);
    const [selectedRowsAvailableExternal, setSelectedRowsAvailableExternal] = useState([]);

    const [selectedRowsFileAssig, setSelectedRowsFileAssig] = useState([]);
    const [selectedRowKeysFileAssig, setSelectedRowKeysFileAssig] = useState([]);

    const [selectedRowKeysAvailableFileAssig, setSelectedRowKeysAvailableFileAssig] = useState([]);
    const [selectedRowsAvailableFileAssig, setSelectedRowsAvailableFileAssig] = useState([]);

    const [selectedRowsExternalAssig, setSelectedRowsExternalAssig] = useState([]);
    const [selectedRowKeysExternalAssig, setSelectedRowKeysExternalAssig] = useState([]);

    const [selectedRowKeysAvailableExternalAssig, setSelectedRowKeysAvailableExternalAssig] = useState([]);
    const [selectedRowsAvailableExternalAssig, setSelectedRowsAvailableExternalAssig] = useState([]);

    const [employeesAssigFile, setEmployeesAssigFile] = useState([]);
    const [employeesAssigExternal, setEmployeesAssigExternal] = useState([]);
    const [disableDif, setDisableDif] = useState(false);
    const [disabledCP, setDisabledCP] = useState(false);
    const [showValid, setShowValid] = useState(true);

    const [diploma, setDiploma] = useState(undefined)
    const {
        siteId
    } = useSelector(state => state.Auth)

    const {
        idSubdirection,
        employeeId
    } = useSelector(state => state.Auth.employeeById)

    //LAYOUT INICIO
    const [localLayAttachment, setLayAttachment] = useState();
    const [dataExcel, setDataExcel] = useState([]);
    const [loadLayDocument, setLoadLayDocument] = useState(false);
    const [isLoadingLayout, setIsLoadingLayout] = useState(false);

    //LAYOUT FIN

    //Genera la estructura de búsqueda
    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input

                    placeholder={`Buscar... ejemplo1;ejemplo2;`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => handleReset(clearFilters, setSelectedKeys)} size="small" style={{ width: 90 }}>
                    Limpiar
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            searchMultiple(value?.split(";").filter(x => x != ""), record[dataIndex]
                .toString()
                .toLowerCase()),
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    useEffect(() => {
        dispatch(TrainingActions.getTrainingSelect(employeeId));
        dispatch(getExternalEmployees())
    }, [dispatch]);
    const [oilTraining, setOilTraining] = useState(false);
    const {
        trainingSelect,
        isLoadTrainingSelect
    } = useSelector(state => state.TrainingReducer);

    const {
        listExternalEmployees,
        isLoadingExternalEmployees,
        listEmployeesByCategory,
        isLoadingEmployeesByCatagory,
        listEmployeesByIdEmployee,
        isLoadListEmployeesById,
        isLoadingDiffusion,
        allIds
    } = useSelector(state => state.CommunicationProgram);

    const optionTraining = trainingSelect.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const dataSourceCourse = questions.length > 0 ? questions[selectedIndex].listCoursesAssigned.map(
        (record) => {
            return {
                'key': record.idCourse,
                'nameWithCode': record.nameWithCode,
                'category': record.category,
                'file': record.file,
                'external': record.external
            }
        }
    ) : [];

    const dataSourceCategories = listEmployeesByCategory.map(
        (record) => {
            return {
                'key': record.employeeId,
                'fullName': record.fullName,
                'employeeId': record.employeeId,
                'categoryName': record.categoryName,
                'companyName': record.companyName
            }
        }
    );

    const dataSourceFile = listEmployeesByIdEmployee.filter(x => !employeesAssigFile.map(y => y.employeeId).includes(x.employeeId)).map(
        (record) => {
            return {
                'key': record.employeeId,
                'fullName': record.fullName,
                'employeeId': record.employeeId,
                'categoryName': record.categoryName,
                'companyName': record.companyName
            }
        }
    )

    const dataSourceFileAssig = employeesAssigFile.map(
        (record) => {
            return {
                'key': record.employeeId,
                'fullName': record.fullName,
                'employeeId': record.employeeId,
                'categoryName': record.categoryName,
                'companyName': record.companyName
            }
        }
    )

    const dataSourceExternal = listExternalEmployees.filter(x => !employeesAssigExternal.map(y => y.employeeId).includes(x.employeeId)).map(
        (record) => {
            return {
                'key': record.employeeId,
                'employeeId': record.employeeId,
                'fullName': record.fullName,
                'userName': record.userName,
                'email': record.email,
                'expirationDate': record.expirationDate,
                'rol': record.rol
            }
        }
    )

    const dataSourceExternalAssig = employeesAssigExternal.map(
        (record) => {
            return {
                'key': record.employeeId,
                'employeeId': record.employeeId,
                'fullName': record.fullName,
                'userName': record.userName,
                'email': record.email,
                'expirationDate': record.expirationDate,
                'rol': record.rol
            }
        }
    )

    const columnsLayout = [
        {
            title: 'Nombre',
            dataIndex: 'fullName',
            key: 'fullName',
            width: 300,
            ellipsis: true,
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            width: 110,
            ellipsis: true,
            ...getColumnSearchProps('employeeId')
        },
        // {
        //     title: 'Puesto',
        //     dataIndex: 'category',
        //     key: 'category',
        //     ellipsis: true,
        //     width: 150,
        //     ...getColumnSearchProps('category'),
        // },
        // {
        //     title: 'Compañía',
        //     dataIndex: 'companyName',
        //     key: 'companyName',
        //     ellipsis: true,
        //     width: 150,
        //     ...getColumnSearchProps('companyName'),
        // }
    ];

    const columnsCategory = [
        {
            title: 'Nombre',
            dataIndex: 'fullName',
            key: 'fullName',
            ellipsis: true,
            width: 300,
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            ellipsis: true,
            width: 100,
            ...getColumnSearchProps('employeeId')
        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('categoryName')
        },
        {
            title: 'Compañia',
            dataIndex: 'companyName',
            key: 'companyName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('companyName')
        }
    ];

    const removeAssigned = (item) => {
        dispatch(removeCourseUsed(item));
    }

    const deleteAssignedProcedures = () => {
        selectedRowKeys.forEach(removeAssigned);
        questions[selectedIndex].listCoursesAssigned = questions[selectedIndex].listCoursesAssigned.filter(course => !selectedRowKeys.includes(course.idCourse));;
        setSelectedRows([]);
        setSelectedRowKeys([]);
        setCanEdit(false);
    }

    const openEditAssignmentModal = () => {
        if (selectedRowKeys.length > 1) {
            setEmployeesAssigFile([]);
            setEmployeesAssigExternal([]);
            setNotApply(false);
        }
        else {
            setEmployeesAssigFile(questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === selectedRowKeys[0]).listEmployeeFile);
            setEmployeesAssigExternal(questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === selectedRowKeys[0]).listEmployeeExternal);
            setNotApply(questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === selectedRowKeys[0]).notApply);
        }

        setVisibleModalEditAssignment(true);
        dispatch(getEmployeesBycategory(
            {
                idCourse: selectedRowKeys.join(','),
                idContract: contract === undefined ? null : contract,
                idWork: work === undefined ? null : work
            })
        );

        dispatch(getEmployeesByIdEmployee({
            idCourse: selectedRowKeys.join(','),
            idContract: contract === undefined ? null : contract,
            idWork: work === undefined ? null : work,
            isAdmin: IsAdmin()
        }));
    }

    const onChangeSelection = (keys, rows) => {
        setSelectedRowKeys(keys)
        setSelectedRows(rows)
        setCanEdit(true);

        if (rows.length > 1) {
            if (rows.reduce((prev, next) => (next.file ? (prev + 1) : prev), 0) > 0) {
                setCanEdit(false);
            } else if (rows.reduce((prev, next) => (next.external ? (prev + 1) : prev), 0) > 0) {
                setCanEdit(false);
            } else {
                setCanEdit(true);
            }
        } else if (rows.length === 0) {
            setCanEdit(false);
        }
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        selectedRows: selectedRows,
        onChange: onChangeSelection
    }

    const onSelectChangeAvailableFile = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableFile(selectedRows);
        setSelectedRowKeysAvailableFile(selectedRowKeys);
        setSelectedRowsFile(selectedRows);
        setSelectedRowKeysFile(selectedRowKeys);
    }

    const rowSelectionAvailableFile = {
        selectedRowKeys: selectedRowKeysFile,
        selectedRows: selectedRowsFile,
        onChange: onSelectChangeAvailableFile
    }

    const onSelectChangeAvailableFileAssig = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableFileAssig(selectedRows);
        setSelectedRowKeysAvailableFileAssig(selectedRowKeys);
        setSelectedRowsFileAssig(selectedRows);
        setSelectedRowKeysFileAssig(selectedRowKeys);
    }


    const rowSelectionAvailableFileAssig = {
        selectedRowKeys: selectedRowKeysFileAssig,
        selectedRows: selectedRowsFileAssig,
        onChange: onSelectChangeAvailableFileAssig
    }

    const onSelectChangeAvailableExternal = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableExternal(selectedRows);
        setSelectedRowKeysAvailableExternal(selectedRowKeys);
        setSelectedRowsExternal(selectedRows);
        setSelectedRowKeysExternal(selectedRowKeys);
    }


    const rowSelectionAvailableExternal = {
        selectedRowKeys: selectedRowKeysExternal,
        selectedRows: selectedRowsExternal,
        onChange: onSelectChangeAvailableExternal
    }

    const onSelectChangeAvailableExternalAssig = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableExternalAssig(selectedRows);
        setSelectedRowKeysAvailableExternalAssig(selectedRowKeys);
        setSelectedRowsExternalAssig(selectedRows);
        setSelectedRowKeysExternalAssig(selectedRowKeys);
    }

    const rowSelectionAvailableExternalAssig = {
        selectedRowKeys: selectedRowKeysExternalAssig,
        selectedRows: selectedRowsExternalAssig,
        onChange: onSelectChangeAvailableExternalAssig
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }

    const handleReset = (clearFilters, setSelectedKeys) => {
        setSelectedKeys([]);
        setSearchText('');
    };

    const setExpirationDateColor = (record) => {
        if (moment(record.expirationDate).isSameOrAfter(moment()) && moment(record.expirationDate).isBefore(moment().add(3, 'days')))
            return "warning"
        if (moment(record.expirationDate).isSameOrAfter(moment().add(3, 'days')))
            return "success"
        return "error"
    }

    const setRolColor = (record) => {
        return record.rol ? "success" : "error";
    }

    const columnsExternal = [
        {
            title: 'Nombre',
            dataIndex: 'fullName',
            key: 'fullName',
            width: 300,
            ellipsis: true,
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Usuario',
            dataIndex: 'userName',
            key: 'userName',
            width: 110,
            ellipsis: true,
            ...getColumnSearchProps('userName')
        },
        {
            title: 'Correo',
            dataIndex: 'email',
            key: 'email',
            ellipsis: true,
            width: 150,
            ...getColumnSearchProps('email'),
        },
        {
            title: 'Vigencia',
            key: 'expiration',
            dataIndex: 'expirationDate',
            fixed: 'right',
            width: 50,
            ellipsis: true,
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setExpirationDateColor(record)} />
                    </Col>
                </Row>
            )
        },
        {
            title: 'Rol',
            key: 'rol',
            dataIndex: 'rol',
            fixed: 'right',
            width: 50,
            ellipsis: true,
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setRolColor(record)} />
                    </Col>
                </Row>
            )
        }
    ];

    const columns = [
        {
            title: 'Procedimiento(s) / Material de Capacitación Asignado(s)',
            dataIndex: 'nameWithCode',
            key: 'nameWithCode',
            ellipsis: true,
            ...getColumnSearchProps('nameWithCode')
        }, {
            title: 'Puesto',
            key: 'category',
            dataIndex: 'category',
            fixed: 'right',
            width: 75,
            ellipsis: true,
            align: 'center',
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setColor(record.category)} />
                    </Col>
                </Row>
            )
        }, {
            title: 'Ficha',
            key: 'file',
            dataIndex: 'file',
            fixed: 'right',
            align: 'center',
            width: 75,
            ellipsis: true,
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setColor(record.file)} />
                    </Col>
                </Row>
            )
        }, {
            title: 'Externo',
            key: 'external',
            dataIndex: 'external',
            fixed: 'right',
            align: 'center',
            ellipsis: true,
            width: 75,
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setColor(record.external)} />
                    </Col>
                </Row>
            )
        }
    ];

    const setColor = (hasAssigned) => hasAssigned ? "success" : "default";

    /* ----------------------------------------------------------- */


    const filterOptionCategory = (inputValue, option) => {
        return option.categoryName.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
    };

    const showConfirm = (type) => {
        confirm({
            title: '¿Desea guardar el Programa de Comunicación?',
            content: name,
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                return ApiService.setCommunicationPrograms(
                    {
                        communicationProgramName: name,
                        communicationProgramDescription: description,
                        idSubdirection: employeeData.idSubdirection,
                        idContract: contract === undefined ? null : contract,
                        idWork: work === undefined ? null : work,
                        idTraining: idTraining,
                        DiplomaRequired: diploma == undefined ? false : diploma
                    }, 'POST')
                    .then(
                        response => {
                            if (response.idCommunicationProgram >= 0) {
                                dispatch(courseAvailableClear());
                                setId(response.idCommunicationProgram)
                                dispatch(clearCommunicationProgram());
                                dispatch(fetchCommunicationProgram({ ...props.formData, idSubdirection: employeeData.idSubdirection, idEmployee :employeeData.employeeId}));
                                dispatch(clearcommunicationProgramFilter());
                                dispatch(fetchCommunicationProgramFilter({ idSubdirection: employeeData.idSubdirection,idEmployee :employeeData.employeeId  }));
                                setIdProgram(response.idCommunicationProgram);
                                setIsSaved(true);
                                confirm({
                                    title: 'Se creó el Programa de Comunicación correctamente.',
                                    content: '¿Desea agregar una nueva Difusión?',
                                    okText: 'Agregar',
                                    cancelText: 'Más tarde',
                                    onOk() {
                                        setCommunicationProgramStatus(true);
                                        setOpen(true);
                                        addQuestion();
                                    },
                                    onCancel() {
                                        props.setTab('1')
                                    },
                                });
                            } else {
                                Modal.warning({
                                    title: response.communicationProgramName,
                                    content: 'El nombre del programa de comunicación ya existe.'
                                });
                            }
                        }, error => {
                            Modal.error({
                                title: 'Ops, error de conexión',
                                content: 'Se perdió la conexión de red, intente más tarde.',
                            });
                        }
                    )
            },
            onCancel() {
                dispatch(clearcommunicationProgramFilter());
                dispatch(fetchCommunicationProgramFilter({ idSubdirection: employeeData.idSubdirection, idEmployee :employeeData.employeeId }));
            },
        });
    }

    const size = (text, property = "") => {
        var ret = "";

        if (property != "") {
            var obj = allIds.filter(x => x.communicationProgramName.toLowerCase() === text.toLowerCase()).filter(y => y.idSubdirection === employeeData.idSubdirection).filter(z => z.idTraining === idTraining)
            if (obj != undefined && idProgram === undefined) {
                if (obj.length > 0) {
                    if (idTraining === undefined && text != undefined) {
                        ret = " Ya esta asignado";
                    } else {
                        ret = " Ya esta asignado";
                    }
                }
            }
        }
        return ret;
    }

    const csize = (text, property = "") => {
        var ret = "grey";
        if (property != "") {
            var obj = allIds.filter(x => x.communicationProgramName.toLowerCase() === text.toLowerCase()).filter(y => y.idSubdirection === employeeData.idSubdirection).filter(z => z.idTraining === idTraining)
            if (obj != undefined && idProgram === undefined) {
                if (obj.length > 0) {
                    if (idTraining === undefined && text != undefined) {
                        ret = "red";
                    } else {
                        ret = "red";
                    }
                }
            }

        }
        return ret;
    }

    const bloqueo = (e) => {

        setDisabledCP(false);


        var obj = allIds.filter(x => x.communicationProgramName.toLowerCase() === name.toLowerCase()).filter(y => y.idSubdirection === employeeData.idSubdirection).filter(z => z.idTraining === idTraining)
        if (obj != undefined && obj.length > 0) {
            setDisabledCP(true);

        }
    }
    useEffect(() => {
        bloqueo("");
    }, [name, idTraining]);

    const showSecondaryConfirm = () => {

        let isCompleted = true;
        for (var i = 0; i < questions.length; i++) {
            var item = questions[i];

            if (item.diffusionName === "") {
                Modal.error({
                    title: 'Difusión',
                    content: questions.length > 1 ? 'El Nombre de las difusiones es Requerido' : 'El Nombre de la difusión es Requerido',
                });
                isCompleted = false;
                break;
            }

            if (item.vigency[0] === null || item.vigency[1] === null) {
                Modal.error({
                    title: 'Difusión',
                    content: questions.length > 1 ? 'La Fecha de las difusiones es Requerido' : 'La Fecha de la difusión es Requerido',
                });
                isCompleted = false;
                break;
            }

            if (item.listCoursesAssigned.length === 0) {
                Modal.error({
                    title: 'Difusión',
                    content: questions.length > 1 ? 'El procedimiento de las difusiones es Requerido' : 'El procedimiento de la difusión es Requerido',
                });
                isCompleted = false;
                break;
            }
        }

        if (isCompleted)
            confirm({
                title: '¿Guardar Difusión?',
                okText: 'Guardar',
                cancelText: 'Cancelar',
                onOk() {
                    let param = [];
                    questions.forEach((item, index) => {
                        let dateInit = item.vigency[0]._i.split("/")
                        let dateEnd = item.vigency[1]._i.split("/")
                        param.push({
                            "idCommunicationProgram": idProgram,
                            "diffusionName": item.diffusionName,
                            "diffusionStartDate": dateInit[2] + "/" + dateInit[1] + "/" + dateInit[0],
                            "diffusionEndDate": dateEnd[2] + "/" + dateEnd[1] + "/" + dateEnd[0],
                            "listCoursesAssigned": item.listCoursesAssigned
                        });
                    })
                    return ApiService.setDiffusion(param, 'POST')
                        .then(
                            response => {
                                dispatch(clearCommunicationProgram());
                                dispatch(fetchCommunicationProgram({ ...props.formData, idSubdirection: employeeData.idSubdirection,idEmployee :employeeData.employeeId }));
                                dispatch(clearcommunicationProgramFilter());
                                dispatch(fetchCommunicationProgramFilter({ idSubdirection: employeeData.idSubdirection,idEmployee :employeeData.employeeId }));
                                setCommunicationProgramStatus(true);
                                setOpen(true);
                                // setResCommunicationProgram(response);
                                props.setTab('1')
                            }, error => {
                                Modal.error({
                                    title: 'Ops, error de conexión',
                                    content: 'Se perdió la conexión de red, intente más tarde.',
                                });
                            }
                        )
                },
                onCancel() {
                    dispatch(clearcommunicationProgramFilter());
                    dispatch(fetchCommunicationProgramFilter({ idSubdirection: employeeData.idSubdirection,idEmployee :employeeData.employeeId }));
                },
            });
    }

    const findSubdir = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.subdirs[values[i]].idSubdirection;
            params.subdirs.forEach(v => {
                if (v.idSubdirection === id) {
                    temp.push(v);

                    (v.idSubdirection === 3) ? setOilService(true) : setOilService(false); //Servicios Petroleros
                }
            });
        }
        setSubdir(temp);
    }

    const handleClick = () => {
        setOpen(!open);
    }

    const generateQuestionList = () => {
        return questions.map((param, i) => (
            <ListItem button className={classes.nested} selected={param.activeKey.isActive} onClick={() => selectedQuestion(param, i)} key={i}>
                <ListItemIcon className={classes.icon}>
                    <Icon type="file" />
                </ListItemIcon>
                <ListItemText secondary={param.diffusionName} />
                <ListItemSecondaryAction>
                    <IconButton edge="end" onClick={() => deleteDiffusion(param)} aria-label="delete">
                        <Icon type="delete" style={styles.addButton} />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        ))
    }
    const selectedQuestion = (param, i) => {
        setSelectedRowKeys([])
        setSelectedRows([])
        setCanEdit(false);

        setSelectedIndex(undefined)
        questions.find(i => {
            return i.activeKey.isActive = false;
        });

        const typeSelected = typeof param;
        if (typeSelected === 'undefined') {
            setSelectedIndex(i)
            questions[i].activeKey.isActive = true;
        } else if (typeSelected === 'object') {
            setSelectedIndex(i)
            questions[i].activeKey.isActive = true;
        }
        onChangeQuestion(param.diffusionName, i)
    }
    const deleteDiffusion = (param) => {

        let index = questions.findIndex(i => {
            return i.activeKey.key === param.activeKey.key;
        });
        selectedQuestion(param, index)
        confirm({
            title: 'Eliminación de Difusión',
            content: '¿Desea eliminar ' + param.diffusionName + ' ?',
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                questions.splice(index, 1)
                if (questions.length > 0) {
                    const key = questions.length - 1;
                    setSelectedIndex(key);
                    questions[key].activeKey.isActive = true;
                    selectedQuestion(questions[key], key);
                } else {
                    setOpen(false);
                    setCommunicationProgramStatus(false);
                }
                setQuestions([...questions]);
            },
            onCancel() {

            },
        });
    }
    const addQuestion = () => {
        const key = questions.length <= 0 ? 0 : questions.length;
        questions.find(i => {
            return i.activeKey.isActive = false;
        });

        let question = [...new Set(questions.concat({
            idCommunicationProgram: idProgram,
            diffusionName: 'Difusión ' + (questions.length + 1),
            vigency: questions.length === 0 ?
                [
                    moment(moment().add('days', questions.length).format('DD/MM/YYYY'), 'DD/MM/YYYY'),
                    moment(moment().add('days', 1).format('DD/MM/YYYY'), 'DD/MM/YYYY')
                ] :
                [
                    moment(questions[questions.length - 1].vigency[1]._i, 'DD-MM-YYYY'),
                    moment(moment(questions[questions.length - 1].vigency[1]._i, 'DD-MM-YYYY').add('days', 1).format('DD/MM/YYYY'), 'DD/MM/YYYY')
                ],
            listCoursesAssigned: [],
            activeKey: { isActive: true, key: key }
        }))];
        setQuestions(question);
        setSelectedIndex(key);
        setCommunicationProgramStatus(true);
        setOpen(true);
    }

    const onChangeQuestion = (value, selected) => {
        questions[selected].diffusionName = value;
        setQuestions([...questions])

        //var obj = questions.filter(x => x != selected).find(y => y.diffusionName.toLowerCase() === value.toLowerCase());
        var obj = [];
        for (var i = 0; i < questions.length; i++) {
            if (questions[i].diffusionName === value && i != selected) {
                obj.push(questions[i])
            }
        }

        if (obj.length != 0) {
            setDisableDif(true)
            setShowValid(false)
        } else {
            var tem = [];
            var duplicados = [];
            questions.map(e => tem.push(e.diffusionName))
            var tempQues = [...tem].sort();
            for (var i = 0; i < tempQues.length; i++) {
                if (tempQues[i + 1] === tempQues[i]) {
                    duplicados.push(tempQues[i]);
                }
            }
            if (duplicados.length != 0) {
                setDisableDif(true);

            } else {
                setDisableDif(false);
            }

            setShowValid(true)
        }


    }

    const onChangeVigency = (date, dateString) => {
        if (dateString[0] !== "")
            questions[selectedIndex].vigency = [moment(dateString[0], 'DD/MM/YYYY'), moment(dateString[1], 'DD/MM/YYYY')];
        else
            questions[selectedIndex].vigency = [null, null];
        setQuestions([...questions])
    }

    const onChangeCourses = (keys, rows) => {
        rows.forEach((item) => {
            questions[selectedIndex].listCoursesAssigned.push({
                ...item,
                category: true,
                file: false,
                external: false,
                notApply: false,
                listEmployeeFile: [],
                listEmployeeExternal: []
            });
        })

        setQuestions([...questions])
    }

    const onChangeCategory = (e) => {
        questions[selectedIndex].listCategory = e;
        setQuestions([...questions])
    }

    const disabledDateVigency = (current) => {
        let totalDiffusion = questions.length;

        if (totalDiffusion === 1) {
            return false;
        }
        else {
            if (selectedIndex === 0) { //Primera difusión
                if (current > moment(questions[selectedIndex + 1].vigency[0]._i, 'DD-MM-YYYY')) { return true }
                else { return false }
            }
            else if (selectedIndex === (totalDiffusion - 1)) { //Ultima difusión
                if (current < moment(questions[selectedIndex - 1].vigency[1]._i, 'DD-MM-YYYY')) { return true }
                else { return false }
            } else { //En medio de difusiones
                if (current < moment(questions[selectedIndex - 1].vigency[1]._i, 'DD-MM-YYYY') || current > moment(questions[selectedIndex + 1].vigency[0]._i, 'DD-MM-YYYY')) { return true }
                else { return false }
            }
        }
    }

    const assignEmployeeFile = () => {
        setEmployeesAssigFile([...employeesAssigFile, ...selectedRowsAvailableFile]);
        setSelectedRowsAvailableFile([]);
        setSelectedRowKeysAvailableFile([]);
        setSelectedRowsFile([]);
        setSelectedRowKeysFile([]);
    }

    const removeEmployeeFile = () => {
        setEmployeesAssigFile(employeesAssigFile.filter(x => !selectedRowKeysAvailableFileAssig.includes(x.employeeId)))
        setSelectedRowsAvailableFileAssig([]);
        setSelectedRowKeysAvailableFileAssig([]);
        setSelectedRowsFileAssig([]);
        setSelectedRowKeysFileAssig([]);
    }

    const assignEmployeeExternal = () => {
        let listOk = selectedRowsAvailableExternal.filter(x => moment(x.expirationDate).isSameOrAfter(moment().add(3, 'days')) && x.rol);
        if (listOk.length !== selectedRowsAvailableExternal.length) {
            let total = selectedRowsAvailableExternal.length - listOk.length;
            if (total === 1) {
                message.warning("El empleado no asignado no cumple con la vigencia o el rol, favor de validar");
            }
            else {
                message.warning("Los empleados no asignados no cumplen con la vigencia o el rol, favor de validar");
            }
        }

        setEmployeesAssigExternal([...employeesAssigExternal, ...listOk]);
        setSelectedRowKeysAvailableExternal([...selectedRowKeysAvailableExternal.filter(x => !listOk.map(y => y.employeeId).includes(x))]);
        setSelectedRowsAvailableExternal([...selectedRowsAvailableExternal.filter(x => !listOk.includes(x))]);
        setSelectedRowKeysExternal([...selectedRowKeysExternal.filter(x => !listOk.map(y => y.employeeId).includes(x))]);
        setSelectedRowsExternal([...selectedRowsExternal.filter(x => !listOk.includes(x))]);
    }

    const removeEmployeeExternal = () => {
        setEmployeesAssigExternal(employeesAssigExternal.filter(x => !selectedRowKeysAvailableExternalAssig.includes(x.employeeId)));
        setSelectedRowsAvailableExternalAssig([]);
        setSelectedRowKeysAvailableExternalAssig([]);
        setSelectedRowsExternalAssig([]);
        setSelectedRowKeysExternalAssig([]);
    }

    const updateAssig = () => {
        selectedRowKeys.forEach((item) => {
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).notApply = notApply;
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).category = !notApply;
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).file = employeesAssigFile.length > 0;
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).external = employeesAssigExternal.length > 0;



            if (selectedRowKeys.length > 1) {
                const employeeAsig = employeesAssigFile.map(item => ({
                    categoryName: item.categoryName,
                    companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }))
                const employeeNew = questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).listEmployeeFile.map(item => ({
                    categoryName: item.categoryName,
                    companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }))

                const employeeLayout = dataExcel.map(item => ({
                    // categoryName: item.category,
                    // companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }))

                let set = new Set([...employeeAsig, ...employeeNew, ...employeeLayout].map(JSON.stringify))
                questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).listEmployeeFile = Array.from(set).map(JSON.parse);
            }
            else {
                const employeeAsig = employeesAssigFile.map(item => ({
                    categoryName: item.categoryName,
                    companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }));
                const employeeLayout = dataExcel.map(item => ({
                    // categoryName: item.category,
                    // companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }));
                let set = new Set([...employeeAsig, ...employeeLayout].map(JSON.stringify))
                
                questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).listEmployeeFile = Array.from(set).map(JSON.parse);//employeesAssigFile;
            }
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).listEmployeeExternal = employeesAssigExternal;
        });
        setVisibleModalEditAssignment(false);
    }
    const checkEdit = () => {
        if (selectedRowKeys?.length > 0 && idTraining === "TK0000000002" && canEdit == false) {
            // handleTabChange(2)
            return false
        }
        return !canEdit;
    }

    const handleTabChange = (tab) => {
        setTabBar(tab);
    }

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const roleAllowed = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Supervisor de aseguramiento de calidad'))
                return true;
        }
        return false;
    }

    const IsAdmin = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Administrador')) {
                return true;
            }
        }
        return false;
    }

    const handleDownloadLayout = () => {
        dispatch(getEmployeeLayout("LayoutColaborador.xlsx"));

        //     getEmployeeLayout,
        // postEmployeeLayout,
    }

    return (
        <div>
            <Grid container direction="row">
                <Grid xs={4} item>
                    <CardContent>
                        <div>
                            <List
                                aria-labelledby="nested-list-subheader"
                                className={classes.root}
                                component="nav"
                                subheader={

                                    <ListSubheader component="div" id="nested-list-subheader">
                                        <ListItem button className={classes.justifyContentFlexEnd} onClick={() => addQuestion()} disabled={id === 0 || disableDif || disabledCP}>
                                            <ListItemIcon className={classes.icon}>
                                                <Icon style={{ fontSize: '20px' }} type='plus-circle' theme='twoTone' />
                                            </ListItemIcon>
                                            <TextEvents
                                                text='Nueva Difusión'
                                                color='gray'
                                                size='small'
                                                weight='regular'
                                            />
                                        </ListItem>
                                    </ListSubheader>
                                }
                            >
                            </List>
                            <Divider />
                            <List dense={false}>
                                <ListItem button disabled={!open}>
                                    <ListItemIcon className={classes.icon}>
                                        <Icon type="folder" />
                                    </ListItemIcon>
                                    <ListItemText primary={name} className={classes.itemText} />
                                    {isCommunicationProgram ? <ListItemSecondaryAction onClick={handleClick}>
                                        {open ? <Icon type="down" /> : <Icon type="up" />}
                                    </ListItemSecondaryAction> : <div />}
                                </ListItem>
                            </List>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <Collapse in={open} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {generateQuestionList()}
                                    </List>
                                </Collapse>
                            </Collapse>
                        </div>
                    </CardContent>
                </Grid>
                {!isCommunicationProgram ?
                    <Grid xs={8} item>
                        <Card className={classes.card}>
                            <CardContent>
                                <div className={classes.content}>
                                    <Grid container direction="row">
                                        <Grid xs={6} item className={classes.gridSeparatorRight}>
                                            <TextInput
                                                value={'-'}
                                                disabled
                                                text='Folio'
                                                mode='input'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                                placeholder=""
                                            >
                                            </TextInput>
                                        </Grid>
                                        <Grid xs={6} item className={classes.gridSeparatorLeft}>
                                            <TextInput
                                                disabled
                                                text='Estatus'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                                mode="multiple"
                                                placeholder="Edición"
                                            >
                                            </TextInput>
                                        </Grid>
                                        <Grid xs={12} item >
                                            <Grid item xs={12}>
                                                <TextEvents
                                                    text='Subdirección origen'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                />
                                                <SubdirectionsContainer>
                                                    {(params) => {
                                                        return (
                                                            <Select
                                                                disabled={true}
                                                                placeholder='Selecciona subdirección'
                                                                value={String(employeeData.idSubdirection)}
                                                                style={{ width: "100%" }}
                                                                onChange={(v) => {
                                                                    findSubdir(params, v);
                                                                }}
                                                            >
                                                                {(employeeData.idSubdirection === 3) ? setOilService(true) : setOilService(false)}
                                                                {
                                                                    params.subdirs.map((item) => {
                                                                        return (
                                                                            <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                                {item.subdirectionName}
                                                                            </Select.Option>
                                                                        )
                                                                    })
                                                                }
                                                            </Select>
                                                        )
                                                    }}
                                                </SubdirectionsContainer>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextEvents
                                                    text='Tipo de capacitación'
                                                    color="darker"
                                                    size='label'
                                                    weight="medium"
                                                />
                                                <Select
                                                    loading={isLoadTrainingSelect}
                                                    disabled={isSaved}
                                                    placeholder="Seleciona tipo de capacitación"
                                                    showSearch
                                                    value={idTraining}
                                                    onChange={(item) => {
                                                        setIdTraining(item);
                                                        setOilTraining(item === "TK0000000001" || item === "TK0000000002");
                                                        if (item !== "TK0000000001" && item !== "TK0000000002") {
                                                            setContract(undefined);
                                                            setWork(undefined);
                                                        }
                                                    }}
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    optionFilterProp="Children"
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {optionTraining}
                                                </Select>
                                            </Grid>

                                            {oilService && oilTraining ? (
                                                <Grid item xs={12}>
                                                    <TextEvents
                                                        text='Contrato'
                                                        color="darker"
                                                        size='label'
                                                        weight="medium"
                                                    />
                                                    <ContractContainer>
                                                        {(params) => {
                                                            return (
                                                                <Select
                                                                    placeholder='Selecciona contrato'
                                                                    value={contract}
                                                                    disabled={isSaved}
                                                                    onChange={(item) => {
                                                                        setContract(item);
                                                                        setWork(undefined)
                                                                    }}
                                                                    allowClear
                                                                    showSearch
                                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                                    optionFilterProp="Children"
                                                                    filterOption={(input, option) =>
                                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                >
                                                                    {
                                                                        params.contract.map((item) => {
                                                                            return (
                                                                                <Select.Option key={item.idContract} value={item.idContract}>
                                                                                    {item.contractName}
                                                                                </Select.Option>
                                                                            )
                                                                        })
                                                                    }
                                                                </Select>
                                                            )
                                                        }}
                                                    </ContractContainer>
                                                </Grid>) : null}

                                            {oilService && oilTraining ? (<Grid item xs={12}>
                                                <TextEvents
                                                    text='OT'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                />
                                                <WorkContainer contract={contract}>
                                                    {(params) => {
                                                        return (
                                                            <Select
                                                                placeholder='Selecciona obra'
                                                                value={work}
                                                                disabled={isSaved}
                                                                onChange={(item) => {
                                                                    setWork(item);
                                                                }}
                                                                allowClear
                                                                showSearch
                                                                style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                                optionFilterProp="Children"
                                                                filterOption={(input, option) =>
                                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                            >
                                                                {
                                                                    params.work.map((item) => {
                                                                        return (
                                                                            <Select.Option key={item.idWork} value={item.idWork}>
                                                                                {item.ot}
                                                                            </Select.Option>
                                                                        )
                                                                    })
                                                                }
                                                            </Select>
                                                        )
                                                    }}
                                                </WorkContainer>
                                            </Grid>) : null}

                                            <TextInput
                                                value={name}
                                                disabled={isSaved}
                                                setValue={setName}
                                                text='Nombre'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                                mode='input'
                                                placeholder='Nombre'
                                                tamano={size(name, "names")}
                                                tcolor={csize(name, "names")}

                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                <div>
                                    <TextEvents
                                        text='Descripción'
                                        color='darker'
                                        size='label'
                                        weight='medium'
                                    />
                                    <TextArea
                                        value={description}
                                        disabled={isSaved}
                                        onChange={e => setDesc(e.target.value)}
                                        autoSize={{ minRows: 5, maxRows: 6 }}
                                        placeholder='Descripción'
                                    />
                                    <Checkbox checked={diploma} onChange={(e) => { setDiploma(e.target.checked) }}>Requiere Diploma</Checkbox>

                                </div>
                                <div className={classes.buttonsContainer}>
                                    <Button
                                        variant='contained'
                                        type='primary'
                                        onClick={showConfirm}
                                        disabled={name === '' || idTraining === undefined || isSaved || disabledCP || disableDif}
                                    > Guardar</Button>
                                    <Button
                                        type="danger" 
                                        ghost
                                        variant='contained'
                                        className={classes.button}
                                        onClick={() => props.setTab('1')}
                                    >Cancelar</Button>
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                    :
                    <Grid xs={8} item>
                        <Card className={classes.card}>
                            <CardContent>
                                <div className={classes.content}>
                                    <Grid container direction="row">
                                        <Grid xs={12} item className={classes.gridSeparatorRight}>
                                            <Grid container>
                                                <Grid item>
                                                    <TextEvents
                                                        text='Nombre '
                                                        color='darker'
                                                        size='label'
                                                        weight='medium'

                                                    />
                                                </Grid>
                                                <div hidden={showValid}>
                                                    <Grid item style={{ marginLeft: '10px' }}>
                                                        <TextEvents
                                                            text=' Ya esta asignado'
                                                            color='red'
                                                            size="5px"
                                                            style="text-align: right !important, margin-left: 12px;"

                                                        />
                                                    </Grid>
                                                </div>
                                            </Grid>
                                            <TextArea
                                                value={questions[selectedIndex].diffusionName}
                                                onChange={e => onChangeQuestion(e.target.value, selectedIndex)}
                                                autoSize={{ minRows: 1, maxRows: 1 }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container direction="row">
                                        <Grid xs={12} item >
                                            <TextEvents
                                                text='Selecciona Fecha'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />

                                            <RangePicker
                                                format="DD/MM/YYYY"
                                                disabledDate={disabledDateVigency}
                                                value={questions[selectedIndex].vigency}
                                                onChange={(date, dateString) => {
                                                    onChangeVigency(date, dateString);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container direction="row" className={classes.gridSeparatorTop} >
                                        <Grid xs={10} item >
                                            <Tooltip placement="bottom" title={'Agregar Procedimiento/Material de capacitación'}>
                                                <IconButton className={classes.editIcon} onClick={() => setVisibleModalProcedureAssign(true)}>
                                                    <Icon type="plus-square" />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                        {questions[selectedIndex].listCoursesAssigned?.length > 0 ? <Grid xs={2} item >
                                            <Tooltip placement="bottom" title={'Eliminar procedimiento(s) seleccionado(s)'}>
                                                <IconButton disabled={!selectedRowKeys?.length > 0} className={classes.deleteIcon} onClick={deleteAssignedProcedures}>
                                                    <Icon type="delete" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip placement="bottom" title={siteId === 'HUB' || (siteId !== 'HUB' && roleAllowed() === true) ? 'Editar procedimiento(s)' : 'Visualizar procedimiento(s)'}>
                                                <IconButton disabled={checkEdit()} className={classes.editIcon} onClick={openEditAssignmentModal}>
                                                    <Icon type={siteId === 'HUB' || (siteId !== 'HUB' && roleAllowed() === true) ? "edit" : "eye"} />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid> : null}
                                    </Grid>

                                    <Grid container direction="row" className={classes.gridSeparatorTop} >
                                        <Grid xs={12} item >
                                            <CourseAvailableContainer id={idProgram}>
                                                {
                                                    (params) => {
                                                        return (
                                                            <ModalProcedureAssignation
                                                                courseAvailable={params.courseAvailables}
                                                                setVisibleModalProcedureAssign={setVisibleModalProcedureAssign}
                                                                visibleModalProcedureAssign={visibleModalProcedureAssign}
                                                                isLoadingCourses={false}
                                                                isLoadingSaveCourses={false}
                                                                onChangeCourses={onChangeCourses}
                                                            />
                                                        )
                                                    }
                                                }
                                            </CourseAvailableContainer>
                                        </Grid>
                                    </Grid>

                                    <Table
                                        columns={columns}
                                        dataSource={dataSourceCourse}
                                        scroll={{ x: "min-content" }}
                                        rowSelection={rowSelection}
                                    />

                                    {
                                        visibleModalEditAssignment ?
                                            <div>
                                                <Modal
                                                    visible={visibleModalEditAssignment}
                                                    onCancel={() => setVisibleModalEditAssignment(false)}
                                                    width={'900px'}
                                                    centered={true}
                                                    footer={[
                                                        <Button key="submit" type="primary" onClick={updateAssig} >
                                                            Guardar
                                                        </Button>,
                                                        <Button key="back" type="danger" ghost onClick={() => setVisibleModalEditAssignment(false)}>
                                                            Cancelar
                                                        </Button>
                                                    ]}
                                                >
                                                    <Tabs type='card' tabBarStyle={{ margin: 0 }} activeKey={activeKey} defaultActiveKey='1' onChange={tab => (handleTabChange(tab))}>
                                                        <TabPane tab='Por Puesto' key='1'>
                                                            <Paper className={classes.paper} key='1'>
                                                                <br></br>
                                                                <Grid container direction="row">
                                                                    <Grid item xs={3}>
                                                                        <TextEvents
                                                                            text={'Colaboradores Asignados'}
                                                                            color='cotemar'
                                                                            size='label'
                                                                            weight='bold'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={7}>
                                                                        <TextEvents
                                                                            text={`${listEmployeesByCategory.length} elementos`}
                                                                            color='gray'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Checkbox checked={notApply} onChange={(e) => { setNotApply(e.target.checked) }}>No aplica</Checkbox>
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid container direction="row">
                                                                    <Grid item xs={12}>
                                                                        <Table
                                                                            columns={columnsCategory}
                                                                            dataSource={dataSourceCategories}
                                                                            scroll={{ y: 300 }}
                                                                            loading={isLoadingEmployeesByCatagory}
                                                                            size="small"
                                                                            rowClassName={notApply ? classes.disabledTable : ''}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Paper>
                                                        </TabPane>
                                                        <TabPane tab='Por Ficha' key='2'>
                                                            <Paper className={classes.paper} key='2'>
                                                                <Grid container direction="row">
                                                                    <Grid item xs={12}>
                                                                        <TextEvents
                                                                            text={'Colaboradores Por Asignar'}
                                                                            color='cotemar'
                                                                            size='label'
                                                                            weight='bold'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Table
                                                                            columns={columnsCategory}
                                                                            dataSource={dataSourceFile}
                                                                            scroll={{ y: 150 }}
                                                                            loading={isLoadListEmployeesById}
                                                                            rowSelection={rowSelectionAvailableFile}
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>

                                                                <Row gutter={[12, 8]}>
                                                                    <Col span={12} align="right">
                                                                        <Tooltip placement="bottom" title={'Asignar colaborador'}>
                                                                            <IconButton className={classes.editIcon} onClick={assignEmployeeFile}>
                                                                                <Icon type="down" />
                                                                            </IconButton>
                                                                        </Tooltip>

                                                                    </Col>

                                                                    <Col span={12}>
                                                                        <Tooltip placement="bottom" title={'Designar colaborador'}>
                                                                            <IconButton className={classes.editIcon} onClick={removeEmployeeFile}>
                                                                                <Icon type="up" />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </Col>
                                                                </Row>

                                                                <Grid container direction="row">
                                                                    <Grid item xs={12}>
                                                                        <TextEvents
                                                                            text={'Colaboradores Asignados'}
                                                                            color='cotemar'
                                                                            size='label'
                                                                            weight='bold'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Table
                                                                            columns={columnsCategory}
                                                                            dataSource={dataSourceFileAssig}
                                                                            scroll={{ y: 150 }}
                                                                            rowSelection={rowSelectionAvailableFileAssig}
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>

                                                            </Paper>
                                                        </TabPane>
                                                        <TabPane tab='Externo' key='3'>
                                                            <Paper className={classes.paper} key='3'>
                                                                <Grid container direction="row">
                                                                    <Grid item xs={12}>
                                                                        <TextEvents
                                                                            text={'Colaboradores Por Asignar'}
                                                                            color='cotemar'
                                                                            size='label'
                                                                            weight='bold'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Table
                                                                            columns={columnsExternal}
                                                                            dataSource={dataSourceExternal}
                                                                            scroll={{ y: 150, x: "min-content" }}
                                                                            loading={isLoadingExternalEmployees}
                                                                            rowSelection={rowSelectionAvailableExternal}
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>

                                                                <Row gutter={[12, 8]}>
                                                                    <Col span={12} align="right">
                                                                        <Tooltip placement="bottom" title={'Asignar colaborador'}>
                                                                            <IconButton className={classes.editIcon} onClick={assignEmployeeExternal}>
                                                                                <Icon type="down" />
                                                                            </IconButton>
                                                                        </Tooltip>

                                                                    </Col>

                                                                    <Col span={12}>
                                                                        <Tooltip placement="bottom" title={'Designar colaborador'}>
                                                                            <IconButton className={classes.editIcon} onClick={removeEmployeeExternal}>
                                                                                <Icon type="up" />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </Col>
                                                                </Row>

                                                                <Grid container direction="row">
                                                                    <Grid item xs={12}>
                                                                        <TextEvents
                                                                            text={'Colaboradores Asignados'}
                                                                            color='cotemar'
                                                                            size='label'
                                                                            weight='bold'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Table
                                                                            columns={columnsExternal}
                                                                            dataSource={dataSourceExternalAssig}
                                                                            scroll={{ y: 150, x: 400 }}
                                                                            rowSelection={rowSelectionAvailableExternalAssig}
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>

                                                            </Paper>
                                                        </TabPane>
                                                        <TabPane tab='Layout' key='4'>
                                                            <Paper className={classes.paper} key='4'>
                                                                <Grid container direction="row">
                                                                    <Grid item xs={12}>
                                                                        <TextEvents
                                                                            text={'Colaboradores Por Asignar'}
                                                                            color='cotemar'
                                                                            size='label'
                                                                            weight='bold'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={7}>
                                                                        <TextEvents
                                                                            text={`${dataExcel.length} elementos`}
                                                                            color='gray'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} align="right">
                                                                        <Button
                                                                            className={classes.button}
                                                                            variant="contained"
                                                                            type="primary"
                                                                            onClick={() => handleDownloadLayout()}
                                                                        >
                                                                            Descargar Layout
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    {
                                                                        dataExcel.length > 0 ?
                                                                            <Table
                                                                                columns={columnsLayout}
                                                                                dataSource={dataExcel}
                                                                                scroll={{ y: 150, x: "min-content" }}
                                                                                loading={isLoadingLayout}
                                                                                size="small"
                                                                                rowClassName={''}
                                                                            /> : <AttachFileXLSX
                                                                                setAttachment={setLayAttachment}
                                                                                localAttachment={localLayAttachment}
                                                                                loadDocument={loadLayDocument}
                                                                                setLoadDocument={setLoadLayDocument}
                                                                                setDataExcel={setDataExcel}
                                                                                dataExcel={dataExcel}
                                                                                idCourse={selectedRowKeys}
                                                                            >
                                                                                {
                                                                                    (params => {
                                                                                        return <div />
                                                                                    })
                                                                                }
                                                                            </AttachFileXLSX>
                                                                    }



                                                                </Grid>
                                                            </Paper>
                                                        </TabPane>
                                                    </Tabs>
                                                </Modal>
                                            </div> : null
                                    }
                                </div>
                            </CardContent>
                        </Card>


                        <div className={classes.buttonsContainer}>
                            <Button
                                variant='contained'
                                type='primary'
                                onClick={showSecondaryConfirm}
                                disabled={questions === '' || disableDif || disabledCP}
                            > Guardar</Button>
                            <Button
                                type="danger" 
                                ghost
                                variant='contained'
                                className={classes.button}
                                onClick={() => props.setTab('1')}
                            >Cancelar</Button>
                        </div>
                    </Grid>}
            </Grid>
        </div>
    );
}